module.exports = __webpack_public_path__ + "img/fj.ccf6e1d5.svg";